import { LoadingButton, LoadingButtonProps } from '@mui/lab'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useIsAvailabilitiesFetching } from '../../../hooks'

const SubmitButton = ({ children, startIcon, ...props }: LoadingButtonProps) => {
  const { formState } = useFormContext()
  const areAvailabilitiesFetching = useIsAvailabilitiesFetching()
  const { t } = useTranslation()
  const { isSubmitting, isValidating } = formState
  const isLoading = isSubmitting || isValidating

  const hasIcon = Boolean(startIcon)

  const iconProps = hasIcon
    ? ({
        startIcon,
        loadingPosition: 'start',
      } as Partial<LoadingButtonProps>)
    : {}

  return (
    <LoadingButton {...props} disabled={areAvailabilitiesFetching} loading={isLoading} {...iconProps} type="submit" variant="contained">
      {children ?? t('common.submit')}
    </LoadingButton>
  )
}

export { SubmitButton }
